import { render, staticRenderFns } from "./vivaMarksEntry.vue?vue&type=template&id=0480fa86&"
import script from "./vivaMarksEntry.vue?vue&type=script&lang=js&"
export * from "./vivaMarksEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports